"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableData = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var date_fns_1 = require("date-fns");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var ui_components_2 = require("@l2p/ui-components");
var useTableData = function (data) {
    var t = (0, next_intl_1.useTranslations)('translation');
    return (0, react_1.useMemo)(function () {
        var table = {
            columns: [
                {
                    field: 'amount',
                    label: t('amount'),
                },
                {
                    field: 'winAmount',
                    label: t('winAmount'),
                },
                {
                    field: 'result',
                    label: t('status'),
                },
                {
                    field: 'placedAt',
                    label: t('placedAt'),
                },
            ],
            rows: [],
        };
        table.rows = data.map(function (item, idx) {
            var amount = item.amount, winAmount = item.winAmount, result = item.result, placedAt = item.placedAt, currency = item.currency;
            var status = result === 'WIN' ? ui_components_2.StatusType.success : ui_components_2.StatusType.error;
            return {
                amount: "".concat(amount, " ").concat((0, apps_shared_1.getCurrencySymbol)(currency)),
                winAmount: "".concat(winAmount, " ").concat((0, apps_shared_1.getCurrencySymbol)(currency)),
                result: (react_1.default.createElement(ui_components_1.StatusText, { status: status, textAlign: "flex-start" }, result)),
                placedAt: (0, date_fns_1.format)(new Date(placedAt), 'HH:mm, dd-LL-yy'),
                idx: idx,
            };
        });
        return table;
    }, [data, t]);
};
exports.useTableData = useTableData;
